import { useQuery } from 'react-query'

import { CacheKeys } from 'helpers/cacheKeys'
import { getFeeItemTypes } from '../components/Statements/StatementCreate'

export function useFeeItemTypes({ enabled = true } = {}) {
  const { data, isLoading, isFetching, refetch } = useQuery(
    `${CacheKeys.FEE_ITEM_TYPES}`,
    () => getFeeItemTypes(),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: true,
      retryDelay: (attempt) => Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
      enabled,
    }
  )

  return {
    feeItemTypes: data,
    refetch,
    isLoading,
    isFetching,
  }
}
